// jquery-shim PRIMEIRO: garante window.jQuery antes de qualquer 'selectize' (interop ESM).
import "./lib/jquery-shim";
// Rollup NÃO embute locales do moment (webpack embutia) — sem este import as datas
// caem silenciosamente p/ inglês (risco nº 8 da checklist de migração).
import moment from "moment";
import "moment/locale/pt-br";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/components/selectizeCustom.css";
// GEN-4235: global — o campo de e-mails (ReactMultiEmail) é usado em telas lazy que não importam o CSS
// (convite de usuários, cadastro em lote de empresas). Importado só nas páginas, o estilo
// some quando a pessoa não passou antes por Configurações/Credenciais.
import "react-multi-email/dist/style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { CookiesProvider } from "react-cookie";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./_react-query/queryClient";
import { msalConfig } from "./authConfig";
import { themeNew } from "./styles/theme";
import "./index.css";
import "./styles/bootstrap.min.css";
// GEN-3498: DEPOIS do Bootstrap, de proposito — sobrescreve as variaveis de cor dele para o
// azul da marca. Antes do Bootstrap nao faz nada, e o defeito volta sem erro nenhum.
import "./styles/bootstrap-brand.css";

moment.locale("pt-br");

// GEN-2959 (PERF-05): com as páginas em chunks lazy, quem está com o app aberto durante um deploy
// pede um chunk com hash antigo que não existe mais — a navegação quebraria com tela branca. O Vite
// avisa por este evento; recarregar busca o index novo. No máximo uma recarga por minuto: se o chunk
// falhar por outro motivo (ex.: rede fora), não entra em laço de recarga — o erro segue para o
// ChunkErrorBoundary do AppShell, que mostra o aviso com a saída. Storage bloqueado também cai lá.
const RECARGA_DE_CHUNK = "taxly:chunkReloadAt";
window.addEventListener("vite:preloadError", (event) => {
  try {
    const ultima = Number(sessionStorage.getItem(RECARGA_DE_CHUNK) ?? 0);
    if (Date.now() - ultima < 60_000) return;
    sessionStorage.setItem(RECARGA_DE_CHUNK, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

//TODO the "currentLocale" information should be filled using the browser data from the user
//Removed Strict to avoid call the backend two times
root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={themeNew}>
      <CookiesProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </CookiesProvider>
    </ChakraProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

reportWebVitals();
// theme={theme}
